import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';

import { LogLevelsDictionary } from '../../dictionaries/LogLevels';
import { AlgoliaService } from '../../services/algolia.service';
import { LogService } from '../../services/log.service';

@Component({
    selector: 'app-search-files',
    templateUrl: './search-files.component.html',
    styleUrls: ['./search-files.component.scss'],
    standalone: false
})
export class SearchFilesComponent {
  casename: string;
  folderId: any;
  @Output() updateResultsEvent = new EventEmitter<string>();
  constructor(
    public dialogRef: MatDialogRef<SearchFilesComponent>,
    private algolia_$: AlgoliaService,
    private log_$: LogService,
    private auth_$: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.casename = data.casename;
    this.folderId = data.folder;
  }

  handleFilesSearch(searchtext: string) {
    this.log_$.storeLog(
      this.auth_$.userData.getValue(),
      LogLevelsDictionary.info,
      { text: searchtext },
      'Search',
      this.casename
    );
    this.algolia_$
      .searchAlgolia(searchtext, this.casename, this.folderId)
      .then(() => this.EmitUpdateFilesResults(searchtext))
      .then(() => this.dialogRef.close());
  }

  EmitUpdateFilesResults(searchQuery?: string) {
    this.updateResultsEvent.emit(searchQuery || '');
  }
}
